function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import { withMedia } from 'react-media-query-hoc';
import moment from 'moment';
import { DatePicker } from '@domain-group/fe-blueprint-ui/datepicker';
import { TextInput } from '@domain-group/fe-blueprint-ui/form';
import { CalendarIcon, ChevronDownIcon } from '@domain-group/fe-co-icon';
import { Filters, ListedDateType, getDateTypeLabel } from '@domain-group/fe-allhomes-search-api';
import Dropdown from '@domain-group/fe-co-allhomes-dropdown';
import MobileDialog from '@domain-group/fe-co-allhomes-mobile-dialog';
import Selector from './selector/selector';
import * as styles from './date-selector.style';
import * as dropdownStyles from './dropdown.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var defaultOptions = [ListedDateType.TODAY, ListedDateType.YESTERDAY, ListedDateType.WITHIN_LAST_WEEK].map(dateType => ({
  value: dateType.name,
  label: getDateTypeLabel(dateType)
}));
class DateSelector extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onSelect", (type, date) => {
      this.changeListedDate(type, date);
    });
    _defineProperty(this, "onSpecificDateSelection", date => {
      this.changeListedDate(ListedDateType.SPECIFIC_DATE.name, moment(date).format('YYYY-MM-DD'));
    });
    _defineProperty(this, "getFullOptions", (selectedDate, formattedDate) => {
      var label = ___EmotionJSX("div", {
        css: styles.specificWrapper
      }, ___EmotionJSX("span", {
        css: styles.specificLabel
      }, "On a specific date"), this.props.media.mobile ? ___EmotionJSX(TextInput, {
        type: "text",
        css: styles.input,
        icon: ___EmotionJSX(CalendarIcon, {
          css: styles.mobileCalendarIcon
        }),
        value: selectedDate ? formattedDate : '',
        placeholder: "Select date",
        readOnly: true
      }) : ___EmotionJSX(CalendarIcon, {
        css: styles.specificCal
      }));
      return [...this.props.options, {
        value: ListedDateType.SPECIFIC_DATE.name,
        component: ___EmotionJSX(DatePicker, {
          initialDate: selectedDate,
          trigger: label,
          alignToTrigger: this.props.media.mobile ? 'left' : 'centre',
          onChange: this.onSpecificDateSelection,
          maxDate: new Date()
        })
      }];
    });
    _defineProperty(this, "setDropdownRef", ref => {
      this.dropdownRef = ref;
    });
    _defineProperty(this, "changeListedDate", (type, date) => {
      this.setState(prevState => {
        var filters = prevState.filters.cloneWith({
          listedDate: {
            type,
            date
          }
        });
        return {
          filters,
          isMobileSelectorOpen: false
        };
      }, () => {
        if (this.dropdownRef && this.dropdownRef.ensureClosed) {
          this.dropdownRef.ensureClosed();
        }
        this.props.onSubmitFilter(this.state.filters);
      });
    });
    _defineProperty(this, "openMobileSelector", () => {
      this.setState({
        isMobileSelectorOpen: true
      });
    });
    _defineProperty(this, "closeMobileSelector", () => {
      this.setState({
        isMobileSelectorOpen: false
      });
    });
    this.state = {
      isMobileSelectorOpen: false,
      filters: new Filters(this.props.listingType, this.props.filters)
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    var filters = new Filters(nextProps.listingType, nextProps.filters);
    if (!isEqual(this.props.filters.getValues(), filters.getValues())) {
      this.setState({
        filters
      });
    }
  }
  render() {
    var _this$props$media = this.props.media,
      mobile = _this$props$media.mobile,
      tablet = _this$props$media.tablet,
      desktop = _this$props$media.desktop;
    var listedDateValue = this.state.filters.listedDate.value;
    var dateType = (listedDateValue === null || listedDateValue === void 0 ? void 0 : listedDateValue.type) || ListedDateType.TODAY.name;
    var date = listedDateValue === null || listedDateValue === void 0 ? void 0 : listedDateValue.date;
    var dateTypeLabel = getDateTypeLabel(ListedDateType[dateType], date);
    return ___EmotionJSX("span", {
      css: styles.dateSelector
    }, ___EmotionJSX("span", null, "Date: "), mobile && ___EmotionJSX("span", null, ___EmotionJSX("button", {
      type: "button",
      css: styles.mobileButton,
      onClick: this.openMobileSelector
    }, dateTypeLabel), ___EmotionJSX(ChevronDownIcon, {
      size: "small",
      css: styles.arrowDownIcon
    })), (tablet || desktop) && ___EmotionJSX(Dropdown, {
      css: dropdownStyles.dropdown,
      align: "centre",
      ref: this.setDropdownRef,
      title: dateTypeLabel,
      anchorClass: "allhomes-dropdown-anchor"
    }, ___EmotionJSX(Selector, {
      name: "allhomes-new-listings__date-selector-options",
      css: styles.options,
      options: this.getFullOptions(date, dateTypeLabel),
      selectedValue: dateType,
      onSelect: this.onSelect
    })), this.state.isMobileSelectorOpen && ___EmotionJSX(MobileDialog, {
      title: "Date",
      closeButton: true,
      onClose: this.closeMobileSelector
    }, ___EmotionJSX(Selector, {
      name: "allhomes-new-listings__date-selector-options",
      css: styles.options,
      options: this.getFullOptions(date, dateTypeLabel),
      selectedValue: dateType,
      onSelect: this.onSelect,
      type: "radio"
    })));
  }
}
DateSelector.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.node,
    component: PropTypes.node,
    indented: PropTypes.bool
  })),
  listingType: PropTypes.string.isRequired,
  filters: PropTypes.instanceOf(Filters),
  media: PropTypes.objectOf(PropTypes.bool),
  onSubmitFilter: PropTypes.func
};
DateSelector.defaultProps = {
  options: defaultOptions,
  filters: {},
  media: {},
  onSubmitFilter: () => {}
};
export default withMedia(DateSelector);
export { DateSelector as BaseDateSelector };